import React from "react";
import classNames from "classnames";
import "./style.scss";

interface Props {
  color:
    | "blue"
    | "red"
    | "light-red"
    | "light-yellow"
    | "dark-red"
    | "gray"
    | "green"
    | "yellow";
  label: string;
  className?: string;
  onClick?: React.EventHandler<any>;
  width?: number;
}
export const Badge = ({ color, label, className, onClick, width }: Props) => {
  return (
    <div
      className={classNames("badge", color, className)}
      onClick={onClick}
      style={{ width: width || "auto" }}
    >
      {label}
    </div>
  );
};
